var a="/api/task-allocation/skip-task",t=5e3;export{t as AUTO_CLOSE_DURATION,a as SKIP_TASK_API_URL};
//# sourceMappingURL=constants.js.map
